/* ==========================================================================
   Scroll reveal — fades elements in on viewport entry.
   Add data-reveal to any element. Optional data-reveal-delay (ms).
   ========================================================================== */

(function () {
  'use strict';

  const revealImmediately = (root) => {
    root.querySelectorAll('[data-reveal]').forEach(
      (element) => element.setAttribute('data-revealed', 'true')
    );
  };
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let revealContent = revealImmediately;

  if ('IntersectionObserver' in window && !reduceMotion) {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const el = entry.target;
          const delay = parseInt(el.dataset.revealDelay || '0', 10);
          setTimeout(() => el.setAttribute('data-revealed', 'true'), delay);
          io.unobserve(el);
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.05 }
    );
    revealContent = (root) => {
      root.querySelectorAll('[data-reveal]').forEach((element) => io.observe(element));
    };
  }

  window.EssentialsVault = window.EssentialsVault || {};
  window.EssentialsVault.revealContent = revealContent;
  document.addEventListener('pdp:content-updated', (event) => {
    revealContent(event.detail?.root || document);
  });
  revealContent(document);
})();
